export default __webpack_public_path__ + "static/media/header-background.2ba1f218.png";